module.exports = __webpack_public_path__ + "static/img/081.2d72c81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/081.png
// module id = vBGV
// module chunks = 0